import { useState } from 'react';
import { useHistory } from 'react-router';
import { EntityRoutes } from 'routes/constants';
import { ContactEntityMapping, ENTITY_TYPE_ID_MAP, EntityType } from 'UI/constants/entityTypes';

import { getAllowedTasks } from '../components/shared/CreationTaskDrawer/CreationTaskDrawer.utils';
import { ORIGIN_TABLE_MAP } from '../constants';

const QUERY_ENTITY_KEY = {
  [ORIGIN_TABLE_MAP.Candidates]: 'candidatesQuery',
  [ORIGIN_TABLE_MAP.Contacts]: 'contactsQuery',
  [ORIGIN_TABLE_MAP.Companies]: 'companiesQuery',
  [ORIGIN_TABLE_MAP.SearchProjectPreview]: 'searchProjectsQuery',
  [ORIGIN_TABLE_MAP.BulkStats]: 'bulkEmailMetricsQuery'
};

const SEARCH_PROJECT_ITEM_ID_TO_ENTITY_TYPE_MAP = {
  1: EntityType.Candidate,
  2: EntityType.HiringAuthority,
  3: EntityType.Contact,
  4: EntityType.Contact,
  5: EntityType.Contact,
  6: EntityType.Company
};

const getEntityTypePerItem = ({ table, item }) => {
  const itemName = item.type?.toLowerCase();
  const OBJECT_TO_EXTRACT_BY_ENTITY_TABLE = {
    [ORIGIN_TABLE_MAP.Candidates]: ENTITY_TYPE_ID_MAP[itemName],
    [ORIGIN_TABLE_MAP.Contacts]: ENTITY_TYPE_ID_MAP[ContactEntityMapping[item.type_id]],
    [ORIGIN_TABLE_MAP.Companies]: ENTITY_TYPE_ID_MAP[itemName],
    [ORIGIN_TABLE_MAP.SearchProjectPreview]:
      ENTITY_TYPE_ID_MAP[SEARCH_PROJECT_ITEM_ID_TO_ENTITY_TYPE_MAP[item.type_id]],
    [ORIGIN_TABLE_MAP.BulkStats]:
      ENTITY_TYPE_ID_MAP[SEARCH_PROJECT_ITEM_ID_TO_ENTITY_TYPE_MAP[item.type_id]]
  };

  return OBJECT_TO_EXTRACT_BY_ENTITY_TABLE[table];
};

const getItemsBySelectionType = ({ selectedItems, selectionType, table }) => {
  if (selectionType === 'exclude') {
    if (table === ORIGIN_TABLE_MAP.Contacts) {
      return selectedItems?.map(item => ({
        id: item.id,
        role_id: item.type_id
      }));
    }

    if (table === ORIGIN_TABLE_MAP.SearchProjectPreview || table === ORIGIN_TABLE_MAP.BulkStats) {
      return selectedItems?.map(item => ({
        id: item.id,
        item_search_project_type: item.type_id
      }));
    }

    return selectedItems?.map(item => item.id.toString());
  }

  return selectedItems?.map(item => {
    return {
      entityId: item.id,
      entityTypeId: getEntityTypePerItem({ table, item })
    };
  });
};

export const useTaskDrawerManager = ({
  table,
  selectedItems,
  selectionType = 'include',
  queryParams = null,
  searchProjectId = null,
  bulkEmailId = null
}) => {
  const history = useHistory();
  const [isDailyPlanTaskDrawerOpen, setIsDailyPlanTaskDrawerOpen] = useState(false);
  const handleOpenTaskDrawer = () => setIsDailyPlanTaskDrawerOpen(true);

  const handleCloseTaskDrawer = () => {
    setIsDailyPlanTaskDrawerOpen(false);
  };
  const handleOnTaskCreated = ({ shouldRedirect = true } = {}) => {
    handleCloseTaskDrawer();
    if (shouldRedirect) {
      history.push(EntityRoutes.DailyPlan);
    }
  };

  const formattedTaskItems = getItemsBySelectionType({ selectedItems, selectionType, table });

  const allowedTasks = getAllowedTasks(table);

  const tasksQuery =
    selectionType === 'exclude'
      ? {
          queryName: QUERY_ENTITY_KEY[table],
          exclude: formattedTaskItems,
          params: queryParams.params,
          searchProjectId,
          bulkEmailId
        }
      : null;

  return {
    isDailyPlanTaskDrawerOpen,
    formattedTaskItems,
    allowedTasks,
    tasksQuery,
    handleCloseTaskDrawer,
    handleOpenTaskDrawer,
    handleOnTaskCreated
  };
};
